import { render, staticRenderFns } from "./InputButtonList.vue?vue&type=template&id=72a0478f&scoped=true&"
import script from "./InputButtonList.vue?vue&type=script&lang=js&"
export * from "./InputButtonList.vue?vue&type=script&lang=js&"
import style0 from "./InputButtonList.vue?vue&type=style&index=0&id=72a0478f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a0478f",
  null
  
)

export default component.exports